<template>
  <form v-on:submit.prevent="submitForm">

      <h2>Stores</h2>
      <div class="form-group"><label for="id">ID :</label><input class="form-control" id="id" readonly="readonly" v-model="store.id"/></div>
      <div class="form-group"><label for="name">Name : </label><input class="form-control" id="name" v-model="store.name"/></div>
      <div class="form-group"><label for="zone">Zone : </label><input class="form-control" id="zone" v-model="store.zone"/></div>
      <div class="form-group"><label for="storeId">Third Id Store : </label><input class="form-control" id="storeId" v-model="store.thirdIdStore"/></div>
      <div class="form-group"><label for="begin">Begin : </label><input class="form-control" id="begin" v-model="store.begin"/></div>
      <div class="form-group"><label for="end">End : </label><input class="form-control" id="end" v-model="store.end"/></div>
      <div class="form-group"><label for="language">Language : </label><input class="form-control" id="language" v-model="store.language"/></div>
      <div class="form-group" v-if="!isRegionNull(store)"><label for="region">Region : </label>
        <input class="form-control" id="region" v-model="store.region.thirdIdRegion"/>
      </div>
      <div v-if="isRegionNull(store)">
        No region associated to this store
      </div>
      <div class="form-group" v-if="!isCountryNull(store)"><label for="country">Country : </label><input class="form-control" id="country" v-model="store.country.thirdIdCountry"/></div>
      <div v-if="isCountryNull(store)">
        No country associated to this store
      </div>
      <div>
        <p>
          <input class="btn btn-edit" type="submit" value="Submit">
        </p>

        <p class="btn btn-deprecate" @click="deprecateStore()">
          <v-icon> mdi-clock </v-icon>
          <input class="btn" value="Deprecate">
        </p>

        <p>
          <router-link class="btn btn-cancel" v-bind:to="{path: 'stores'}">
            <v-icon>mdi-cancel</v-icon>
            <input class="btn" type="submit" value="Cancel">
          </router-link>
        </p>
      </div>
    </form>
</template>

<script>
import {parameters} from "../../parameters";
import {httpClient} from "../../requesters/httpClient";

export default {
  name: 'EditStore',

  async created() {
    await httpClient.get(`${parameters.posdataRefUrl}/stores/` + this.$route.query.id)
      .then((response)=> {
        this.store = response.data;
      })
      .catch((error)=> {
        throw error;
      });
  },
  data() {
    return {
      store: {},
      storeSent: null
    }
  },
  methods: {
    isCountryNull: function(store){

      return store === null || store.country === null;
    },
    isRegionNull: function(store){
      return store.region === null;
    },
    async submitForm(e) {
      await httpClient.post(`${parameters.posdataRefUrl}/overwrite/store`,
        this.store
    );

      if (!this.areFieldsEmpty()) {
        await this.$alert("The store was overwritten THEN updated");

        await this.$router.push('stores');


        e.preventDefault();
      } else {
        await this.$alert("Some mandatory fieds are empty")
      }
    },
    areFieldsEmpty: function(){
      if (this.store.thirdIdStore === '' || this.store.name === ''
        || this.store.zone === '' || this.store.language === ''){
        return true;
      }
    },
    async deprecateStore(){
      await httpClient.post(`${parameters.posdataRefUrl}/store/` + this.store.id + `/deprecate`)
        .then(function (response){
          if (response.status === 200){
            alert("The store was deprecated")
          } else {
            alert("Store is not present in database and can't be deprecated")
          }

        })
      await this.$router.push('stores')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/stores/EditStore.vue